import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.u3q_1 = new (CouplingImages())('overlayPng', 'graphqlSvg', 'logoSvg', 'noPartyImagePath', 'noPlayerImagePath', 'frodo', 'samwise', 'grayson', 'wayne', 'rosie', 'wendy', 'robPng', 'autumnPng');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CouplingImagesClass;
function CouplingImages() {
  if (CouplingImagesClass === VOID) {
    class $ {
      constructor(overlayPng, graphqlSvg, logoSvg, noPartyImagePath, noPlayerImagePath, frodo, samwise, grayson, wayne, rosie, wendy, robPng, autumnPng) {
        Companion_getInstance();
        this.h3q_1 = overlayPng;
        this.i3q_1 = graphqlSvg;
        this.j3q_1 = logoSvg;
        this.k3q_1 = noPartyImagePath;
        this.l3q_1 = noPlayerImagePath;
        this.m3q_1 = frodo;
        this.n3q_1 = samwise;
        this.o3q_1 = grayson;
        this.p3q_1 = wayne;
        this.q3q_1 = rosie;
        this.r3q_1 = wendy;
        this.s3q_1 = robPng;
        this.t3q_1 = autumnPng;
      }
      toString() {
        return 'CouplingImages(overlayPng=' + this.h3q_1 + ', graphqlSvg=' + this.i3q_1 + ', logoSvg=' + this.j3q_1 + ', noPartyImagePath=' + this.k3q_1 + ', noPlayerImagePath=' + this.l3q_1 + ', frodo=' + this.m3q_1 + ', samwise=' + this.n3q_1 + ', grayson=' + this.o3q_1 + ', wayne=' + this.p3q_1 + ', rosie=' + this.q3q_1 + ', wendy=' + this.r3q_1 + ', robPng=' + this.s3q_1 + ', autumnPng=' + this.t3q_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.h3q_1);
        result = imul(result, 31) + getStringHashCode(this.i3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t3q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CouplingImages()))
          return false;
        if (!(this.h3q_1 === other.h3q_1))
          return false;
        if (!(this.i3q_1 === other.i3q_1))
          return false;
        if (!(this.j3q_1 === other.j3q_1))
          return false;
        if (!(this.k3q_1 === other.k3q_1))
          return false;
        if (!(this.l3q_1 === other.l3q_1))
          return false;
        if (!(this.m3q_1 === other.m3q_1))
          return false;
        if (!(this.n3q_1 === other.n3q_1))
          return false;
        if (!(this.o3q_1 === other.o3q_1))
          return false;
        if (!(this.p3q_1 === other.p3q_1))
          return false;
        if (!(this.q3q_1 === other.q3q_1))
          return false;
        if (!(this.r3q_1 === other.r3q_1))
          return false;
        if (!(this.s3q_1 === other.s3q_1))
          return false;
        if (!(this.t3q_1 === other.t3q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CouplingImages');
    CouplingImagesClass = $;
  }
  return CouplingImagesClass;
}
//region block: exports
export {
  CouplingImages as CouplingImagesci5yi3b0zpw0,
  Companion_getInstance as Companion_getInstance183u30r0z0tam,
};
//endregion

//# sourceMappingURL=CouplingImages.mjs.map
